import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import BrandOverview from './components/BrandOverview';
import CoreAdvantages from './components/CoreAdvantages';
import BusinessOverview from './components/BusinessOverview';
import EnterpriseNews from './components/EnterpriseNews';
import PartnershipCTA from './components/PartnershipCTA';

export default function Home() {
  return (
    <div className="ui-page ui-page--home-lite">
      <Navbar transparent />
      <main>
        <HeroSection />
        <BrandOverview />
        <CoreAdvantages />
        <BusinessOverview />
        <EnterpriseNews />
        <PartnershipCTA />
      </main>
      <Footer />
    </div>
  );
}
